import React from 'react';
import logo from '../assets/icon.png';
import './Loader.css';

const Loader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader-container">
        {/* Logo and Brand */}
        <div className="loader-brand">
          <div className="loader-logo">
            <img src={logo} alt="Mealzy Foods" />
            <div className="logo-pulse"></div>
          </div>
          <h1 className="loader-title">Mealzy Foods</h1>
          <p className="loader-subtitle">Good Food • Great Mood</p>
        </div>

        {/* Animated Elements */}
        <div className="loader-animation">
          {/* Cooking Animation */}
          <div className="cooking-pot">
            <div className="pot-body"></div>
            <div className="pot-handle"></div>
            <div className="steam steam-1"></div>
            <div className="steam steam-2"></div>
            <div className="steam steam-3"></div>
          </div>

          {/* Food Icons Animation */}
          <div className="floating-foods">
            <div className="food-item food-1">🍛</div>
            <div className="food-item food-2">🥗</div>
            <div className="food-item food-3">🍅</div>
            <div className="food-item food-4">☕</div>
          </div>
        </div>

        {/* Loading Bar */}
        <div className="loading-bar-container">
          <div className="loading-bar">
            <div className="loading-progress"></div>
          </div>
          <p className="loading-text">Preparing your fresh experience...</p>
        </div>

        {/* Spinning Elements */}
        <div className="loader-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring ring-2"></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
